import { createSlice } from "@reduxjs/toolkit";
import store from "./store";
import { ProductType } from "../data/enums";


export const cartReducer = createSlice({
   name: "cart",
   initialState: {
      itemCount: 0,
      items: {},
      payment: false
   },
   reducers: {
      resetCart: (state) => {
         state.items = {}
         state.itemCount = 0;
      },
      setPayment: (state, action) => {
         state.payment = action
      },
      addItem: (state, action) => {

         const productsFromSession = window.sessionStorage.getItem("products");
         let cartItems = productsFromSession ? JSON.parse(productsFromSession) : null;
         if (!cartItems) {
            state.items = {};
         }
         sessionStorage.removeItem('products');
         const companyUser = sessionStorage.getItem("company") && sessionStorage.getItem("userDetails") ? true : false

         if (companyUser || action.payload.selectedProduct.productTypeId && action.payload.selectedProduct.productTypeId == ProductType.Goods) {
            const item = state.items[action.payload.selectedProduct.productId];
            if (item === undefined) {
               state.items={}
               state.items[action.payload.selectedProduct.productId] = {
                  selectedProduct: action.payload.selectedProduct,
                  qty: 1
               };
               state.itemCount = 1;
            }
            else {
               item.qty++;
               state.itemCount++;
            }
            window.sessionStorage.setItem("products", JSON.stringify(state.items));
         }
         else {

            //remove this line if want to add multiple products
            state.items = {};
            const item = state.items[action.payload.selectedProduct.productId];
            if (item === undefined) {
               state.items[action.payload.selectedProduct.productId] = {
                  selectedProduct: action.payload.selectedProduct,
                  qty: 1
               };
               state.itemCount++;
            }
            else {
               item.qty++;
               state.itemCount++;
            }

            // ## start region -  remove this region and uncomment the above if you want to add multiple products
            state.items[action.payload.selectedProduct.productId] = {
               selectedProduct: action.payload.selectedProduct,
               qty: 1
            };
            state.itemCount = 1;
            window.sessionStorage.setItem("products", JSON.stringify(state.items));
            ///// ## end region

         }




      },

      removeItem: (state, action) => {

         const item = state.items[action.payload.productId];
         if (item === undefined) return;
         item.qty === 1 ? delete state.items[action.payload.productId] : item.qty--;
         state.itemCount--;
         sessionStorage.removeItem('products');
         window.sessionStorage.setItem("products", JSON.stringify(state.items));
      },
      setAmount: (state , action) => {
         const item = state.items[action.payload.selectedProduct.productId];
         if (item === undefined) return;
         item.qty = Number(action.payload.qty)
         state.itemCount = Number(action.payload.qty)
         sessionStorage.setItem("products", JSON.stringify(state.items));
      }


   }
});
export const { addItem, removeItem, resetCart, setPayment ,setAmount} = cartReducer.actions;

export const selectCartItems = (state) => state.cart.items;
export const selectCartCount = (state) => state.cart.itemCount;

export default cartReducer.reducer;